// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacySearchResponseModel {
    static getAttributeTypeMap() {
        return PharmacySearchResponseModel.attributeTypeMap;
    }
}
PharmacySearchResponseModel.discriminator = undefined;
PharmacySearchResponseModel.additionalProperties = false;
PharmacySearchResponseModel.attributeTypeMap = [
    {
        "name": "pharmacies",
        "baseName": "pharmacies",
        "type": ""
    },
    {
        "name": "hasAdditionalMatches",
        "baseName": "hasAdditionalMatches",
        "type": "boolean"
    },
];
//# sourceMappingURL=pharmacySearchResponseModel.js.map